import { Button } from "@mui/material";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import { Panel } from "@poseidon/ui/components/Panel";
import { Formik } from "formik";
import * as api from "../../api";
import { useCallback } from "react";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import {
  FormikDisabler,
  usePermissions,
} from "@poseidon/ui/components";

export const EditSailorRiskProfileFormPanel = ({
  title,
  children,
  initialValues,
  validationSchema,
  mapValues,
  sailor,
  disabled,
}) => {
  const { canWrite } = usePermissions();
  const { setToast } = useToastMessage();
  const { setError } = useErrorMessage();

  const submitHandler = useCallback(
    async (values) => {
      console.log("updateSailorRiskProfile", sailor.id, values);
      try {
        await api.updateSailorRiskProfile({
          sailorId: sailor.id,
          values: mapValues ? mapValues(values) : values,
        });
        setToast("Successfully updated Risk Profile for Sailor");
      } catch (error) {
        setError(error.message);
      }
    },
    [setError, setToast, mapValues, sailor.id]
  );

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={submitHandler}
    >
      {({ dirty, isSubmitting }) => (
        <Form>
          <FormikDisabler disabled={disabled || !canWrite} />
          <Panel
            title={title}
            expandable
            actions={
              <Button
                variant="contained"
                size="small"
                type="submit"
                disabled={!dirty || isSubmitting}
              >
                Save
              </Button>
            }
          >
            {children}
          </Panel>
        </Form>
      )}
    </Formik>
  );
};
